function CircleCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 24 24"
    >
      <path
        fill="#77EC84"
        d="M12.5 2.2a10.3 10.3 0 1010.3 10.3A10.299 10.299 0 0012.5 2.2zm-1.998 15.077l-3.79-3.585.92-.918 2.865 2.676 7.027-6.874.92.92z"
      ></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export default CircleCheckIcon;
